<script>
	const sessionItems = [
		"token",
		"name",
		"email",
		"role",
		"companyId",
		"id",
		"auth_token",
	];

	// localStorage.setItem('token', 'teste');
	// localStorage.setItem('role', 'ADMIN');

	export default {
		setSessionData: (sessionData) => {
		
			sessionItems.forEach(sessionItem => {
				if (sessionItem in sessionData) {
					
					localStorage.setItem(sessionItem, sessionData[sessionItem]);
				}
			});
			return true;
		},
		isActive: () => {
			let token = localStorage.getItem("token");
			if (token) {
				return true;
			}
			return false;
		},
		clear: () => {
			localStorage.clear();
			return true;
		},
		getItem: (sessionItem) => {
			if (sessionItems.includes(sessionItem)) {
				return localStorage.getItem(sessionItem);
			}
			throw Error("ERR_INVALID_SESSION_ITEM");
		},
		setItem: (sessionItem, value) => {
			if (sessionItems.includes(sessionItem)) {
				localStorage.setItem(sessionItem, value);
				return;
			}
			throw Error("ERR_INVALID_SESSION_ITEM");
		}
	}
</script>


// WEBPACK FOOTER //
// src/api/session.vue